import ReactDOM from 'react-dom';

//context
import { useContext} from 'react';
import {ListContext} from '@/context/ListContext';
import CombinedFeedContextProvider from '@/context/CombinedFeedContext';

//components
import CombinedFeed from  '@/components/page/Content/CombinedFeed/CombinedFeed';
import SourceListsTab from  '@/components/page/Content/CombinedFeed/SourceListsTab';


const SharedCombinedFeedPortals = () => {
    let defaultSort = "";

    const feedContainer = document.getElementById('react-feed-portal');
    const sourceContainer = document.getElementById('react-source-lists-portal');
    const {setAppGuid, setAppId, setListId, listId, setOrgPermission, setListContentPermission} = useContext(ListContext)

    if (!feedContainer && !sourceContainer) {
        return null;
    } else {
        const targetContainer = feedContainer || sourceContainer;
        if (targetContainer) {
            setAppGuid(targetContainer?.getAttribute?.('data-app-guid'));
            setAppId(targetContainer?.getAttribute?.('data-app-id'));
            setOrgPermission(targetContainer?.getAttribute?.('data-orgpermission'));
            setListContentPermission(targetContainer?.getAttribute?.('data-contentpermission'));
            defaultSort = targetContainer?.getAttribute?.('data-default-sort-type') ?? ""

            if(!listId || listId ==='0') {
                setListId(targetContainer?.getAttribute?.('data-menu-id'))
            };
        }
    }

    return (
        <CombinedFeedContextProvider defaultSort={defaultSort}>
            <>
                {feedContainer &&
                    ReactDOM.createPortal(
                        <CombinedFeed />,
                        feedContainer
                    )}

                {sourceContainer &&
                    ReactDOM.createPortal(
                        <SourceListsTab />,
                        sourceContainer
                    )}
            </>
        </CombinedFeedContextProvider>
    );
};

export default SharedCombinedFeedPortals;